<template>
  <div class>
    <p class="caption font-weight-regular ma-0 pa-0 text-center" :class="textColor">
      {{$t('view')}}
      <a
        @click.prevent="$router.push('/privacy-policy-travelzoo')"
        class="a-underline"
        :class="textColor"
      >Travelzoo's Privacy Policy</a>
    </p>

    <p class="caption font-weight-regular ma-0 pa-0 text-center" :class="textColor">
      {{$t('read')}}
      <a
        @click.stop.prevent="$router.push('/terms-and-conditions')"
        class="a-underline"
        :class="textColor"
      >Travelzoo's Terms &amp; Conditions</a>
    </p>

    <p class="caption font-weight-regular ma-0 pa-0 text-center" :class="textColor">
      <a
        @click.stop.prevent="($event) => goToLink('https://www.travelzoo.com/ca/help-faq/#:~:text=If%20you%20discover%20you%20are,%2DSun%209am%20%2D%209pm%20ET ', $event)"
        class="a-underline"
        :class="textColor"
      >{{$t('contact_us')}}</a> {{$t('travelzoo')}}
      <br />{{$t('travelzoo_address')}}
    </p>
    <p
      class="caption font-weight-regular ma-0 pa-0 text-center"
      :class="textColor"
    >{{$t('travelzoo_tico_no')}}: 50020241</p>
    <!-- <v-row justify="center">    <img class="responsive-image mt-1 text-center" src="@/assets/images/tico.png" alt="tico logo" /></v-row> -->
  </div>
</template>

<script>
export default {
  props: {
    textColor: {
      default: 'white--text'
    }
  }
}
</script>

<style lang="scss" scoped>
.a-underline {
  text-decoration: underline;
}

.responsive-image {
  max-height: 40px;
  width: auto;
}
</style>
